import React from "react";
import {
  Box,
  Typography,
} from "@mui/material";

const SummarySection = ({
  total,
  received,
  balance,
}) => {
  return (
    <Box
      sx={{
        mt: 4,
        p: 3,
        borderRadius: 3,
        background: "#f1f5f9",
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 2,
      }}
    >

      <Typography
        fontWeight={800}
        fontSize={18}
      >
        💰 Total: ₹ {total}
      </Typography>


      <Typography>
        Received: ₹ {received}
      </Typography>


      <Typography color="error">
        Balance: ₹ {balance}
      </Typography>


    </Box>
  );
};

export default SummarySection;